import { render } from "./TabItem.vue?vue&type=template&id=54120daa&scoped=true"
import script from "./TabItem.vue?vue&type=script&lang=js"
export * from "./TabItem.vue?vue&type=script&lang=js"

import "./TabItem.vue?vue&type=style&index=0&id=54120daa&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-54120daa"

export default script